// Arrivée depuis une page du site vitrine (/signup?start=site|retro|budget) :
// après la création du compte, on va droit à l'outil concerné.
export type StartIntent = 'site' | 'retro' | 'budget';

export const RETRO_SIGNUP_URL = '/signup?start=retro';
export const BUDGET_SIGNUP_URL = '/signup?start=budget';
export const SITE_SIGNUP_URL = '/signup?start=site';

export function startIntent(search = window.location.search): StartIntent | null {
  const start = new URLSearchParams(search).get('start');
  return start === 'site' || start === 'retro' || start === 'budget' ? start : null;
}
